<template>
  <div>
    <div>
      <button
        v-if="!withoutDeleteButton"
        class="btn btn-default preview-image__button_delete"
        type="button"
        @click="deleteFile"
      >
        Удалить файл
      </button>
    </div>
    <div class="file-input">
      <input
        @change="showFileInfo"
        :accept="acceptTypes"
        ref="inputElem"
        type="file"
        id="file"
        class="file"
      />
      <label for="file">
        {{ resultLabel }}
      </label>
    </div>
  </div>
</template>

<script>
import { useNotification } from "@/_shared/mixins";
export default {
  mixins: [useNotification],
  props: {
    withoutDeleteButton: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "Выберите файл",
    },
    acceptTypes: {
      type: String,
      default: "image/*",
    },
  },
  emits: ["on-select-file", "on-delete"],
  data() {
    return {
      fullsizeImageWasOpened: false,
      previewWasLoaded: true,
      fileInfo: "",
    };
  },
  computed: {
    resultLabel() {
      const MAX_SYMBOLS = 50;
      let result = !!this.fileInfo ? this.fileInfo : this.label;
      if (result.length > MAX_SYMBOLS) {
        result = `${result.slice(0, 49)}...`;
      }
      return result;
    },
  },
  methods: {
    deleteFile() {
      this.fileInfo = "";
      this.$emit("on-delete");
    },
    showFileInfo(event) {
      const [file] = event.target.files;
      const { name, size } = file;
      if (this.fileIsTooLarge(size)) {
        return;
      }
      const formattedSize = (size / 1000).toFixed(2);
      const fileInfo = `${name} - ${formattedSize}KB`;
      this.fileInfo = fileInfo;
      this.$emit("on-select-file", file);
      this.$refs.inputElem.value = "";
    },
    fileIsTooLarge(size) {
      const maxSize = 2097152;
      if (size >= maxSize) {
        this.showErrorNotification("Файл не может быть больше 2 МБ");
        this.$refs.inputElem.value = "";
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped>
.file {
  opacity: 0;
  width: 0.1px;
  height: 0.1px;
  position: absolute;
}

.file-input,
.file-input label,
.file {
  max-width: 300px;
}

.preview-image__button_delete {
  margin-bottom: 1em;
}

.form__image_preview {
  display: inline-flex;
  flex-direction: column;
}

.preview-image {
  -webkit-box-shadow: 0px -2px 35px 0px rgba(34, 60, 80, 0.38);
  -moz-box-shadow: 0px -2px 35px 0px rgba(34, 60, 80, 0.38);
  box-shadow: 0px -2px 35px 0px rgba(34, 60, 80, 0.38);
  margin: 1em 0;
  max-width: 10em;
  position: relative;
}

.preview-image_loading {
  width: 10em;
}

.preview-image:hover::after {
  opacity: 0.5;
  transition: 0.3s;
}

.preview-image:hover {
  cursor: pointer;
}

.preview-image::after {
  border-bottom-left-radius: 12px;
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  z-index: 5;
  background-color: rgba(0, 0, 0, 0.6);
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23fff' d='M15,10H12V7a1,1,0,0,0-2,0v3H7a1,1,0,0,0,0,2h3v3a1,1,0,0,0,2,0V12h3a1,1,0,0,0,0-2Zm6.71,10.29L18,16.61A9,9,0,1,0,16.61,18l3.68,3.68a1,1,0,0,0,1.42,0A1,1,0,0,0,21.71,20.29ZM11,18a7,7,0,1,1,7-7A7,7,0,0,1,11,18Z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  width: 40px;
  height: 40px;
}

.preview-image::after:hover {
  cursor: pointer;
  opacity: 0.5;
  transition: 0.3s;
}

.preview-image img {
  width: inherit;
  height: inherit;
  object-fit: cover;
}
.form__image_unset {
  margin-top: 0.5em;
  margin-bottom: 1em;
}

.form__input_image {
  margin-top: 1em;
}

.file-input label {
  position: relative;
  border-radius: 4px;
  border: #337ab7 2px solid;
  box-shadow: 0 4px 7px rgba(0, 0, 0, 0.4);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #337ab7;
  font-weight: bold;
  padding: 1em 0.5em;
  text-align: center;
  cursor: pointer;
  transition: transform 0.2s ease-out;
}

input:hover + label,
input:focus + label {
  transition: 0.2s;
  opacity: 0.6;
}
</style>



// WEBPACK FOOTER //
// src/_shared/components/ui/FileInput.vue